export default __webpack_public_path__ + "static/media/TeacherRoleIcon.73777c00.svg";